import React, { useEffect } from 'react';
import { serviciosArray } from '../../json/docservArray';
import CardDocumentserv from './CardDocumentserv';


const Servicios = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
	        <div className="container pt-5">
	        	<div className="row">
	        		<div className="col-12">
	        		</div>
	        		<div>
                <h3 className='title'>Servicios</h3>
                <hr className='hr-gob'/>
            </div>
	            </div>
	        </div>
	        <CardDocumentserv array={serviciosArray} id={'arc'}/>
        </>
    )
}

export default Servicios;
